/**
 * Utility class that launches an instance of the DownloadListDialog.
 */

import DownloadListDialog from './download-list-dialog';
export default class DownloadListDialogLauncher {

  constructor(selectedSitesModel) {

    // Cache references.
    this._selectedSitesModel = selectedSitesModel;

  }

  launch() {
    new DownloadListDialog({
      selectedSitesModel: this._selectedSitesModel
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/selected-sites-panel/dialogs/download-list-dialog-launcher.js